import React from "react";
import { Button } from "../ui/button";
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
	DialogFooter,
} from "../ui/dialog";

import { i18n } from "../../translate/i18n";

// `confirmLabel` deixa o botão dizer a ação ("Excluir cargo") em vez de "Ok".
// Num diálogo que apaga coisa, "Ok" não informa nada a quem está inseguro —
// e é justamente aí que a pessoa precisa saber o que vai acontecer.
const ConfirmationModal = ({
	title,
	children,
	open,
	onClose,
	onConfirm,
	confirmLabel,
	// Confirmação que não destrói nada ("registrar aceite") não pinta de
	// vermelho: vermelho ensina que o clique é perigoso.
	confirmVariant = "destructive",
}) => {
	return (
		<Dialog open={open} onOpenChange={() => onClose(false)}>
			<DialogContent className="sm:max-w-md">
				<DialogHeader>
					<DialogTitle>{title}</DialogTitle>
				</DialogHeader>
				{/* `div`, não `p`: o aviso de algumas telas é uma lista do que a
				    ação leva junto, e bloco dentro de parágrafo é HTML inválido —
				    o React desmonta a árvore em runtime. Texto simples continua
				    aparecendo igual. */}
				<div className="text-sm text-muted-foreground">{children}</div>
				<DialogFooter>
					<Button variant="outline" onClick={() => onClose(false)}>
						{i18n.t("confirmationModal.buttons.cancel")}
					</Button>
					<Button
						variant={confirmVariant}
						onClick={() => {
							onClose(false);
							onConfirm();
						}}
					>
						{confirmLabel || i18n.t("confirmationModal.buttons.confirm")}
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
};

export default ConfirmationModal;
